import React, { useState, useEffect } from 'react';
import { Mail, BookOpen, FileText, Landmark, Search, Menu, X, Building2, Info, Link as LinkIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { ContactModal } from './ContactModal';
import { PaymentModal } from './PaymentModal';

export function TopHeader() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    // Listen for the custom event to open the contact modal
    const handleOpenContactModal = () => {
      setIsContactModalOpen(true);
    };
    
    window.addEventListener('openContactModal', handleOpenContactModal);
    
    return () => {
      window.removeEventListener('openContactModal', handleOpenContactModal);
    };
  }, []);


  const navItems = [
    {
      icon: <Mail className="w-4 h-4" />,
      label: 'Kontakta Oss',
      action: () => setIsContactModalOpen(true)
    },
    {
      icon: <Info className="w-4 h-4" />,
      label: 'Läsvärt om Stiftelser',
      to: '/allt-om-stiftelser'
    },
    {
      icon: <BookOpen className="w-4 h-4" />,
      label: (
        <span className="flex flex-col">
          <span>Stiftelse Nyheter</span>
          <span className="text-xs bg-[#F2C1D1] px-1 py-0.5 rounded text-white text-center">Start Q2/2025</span>
        </span>
      ),
      to: '/blogg'
    },
    {
      icon: <FileText className="w-4 h-4" />,
      label: (
        <span className="flex flex-col">
          <span>Ansökningshjälpen AI</span>
          <span className="text-xs bg-[#F2C1D1] px-1 py-0.5 rounded text-white text-center">Start Q2/2025</span>
        </span>
      ),
      to: '/premium'
    },
    {
      icon: <LinkIcon className="w-4 h-4" />,
      label: (
        <span className="flex flex-col">
          <span>Projektbörsen</span>
          <span className="text-xs bg-[#F2C1D1] px-1 py-0.5 rounded text-white text-center">Start Q2/2025</span>
        </span>
      ),
      to: '/projektborsen'
    },
    {
      icon: <Building2 className="w-4 h-4" />,
      label: (
        <span className="flex flex-col">
          <span>Starta stiftelse</span>
          <span className="text-xs bg-[#F2C1D1] px-1 py-0.5 rounded text-white text-center">Start Q2/2025</span>
        </span>
      ),
      to: '/starta-stiftelse'
    }
  ];

  return (
    <>
      <nav className="sticky top-0 z-50 bg-[#A3C1DA] text-white py-2.5 px-4 border-b border-[#D1B3C4]/20 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <Link 
            to="/" 
            className="flex items-center gap-1.5 sm:gap-2 group cursor-pointer"
            aria-label="Gå till startsidan"
          >
            <div className="relative">
              <Landmark className="w-5 h-5 sm:w-6 sm:h-6 text-[#F2C1D1] transition-transform group-hover:scale-110" />
              <Search className="w-2.5 h-2.5 sm:w-3 sm:h-3 text-[#F3E5AB] absolute -bottom-1 -right-1 transition-transform group-hover:scale-110" />
            </div>
            <span className="text-base sm:text-lg font-semibold tracking-wide text-white">
              SÖKASTIFTELSEMEDEL.SE
            </span>
          </Link>

          <div className="hidden md:flex flex-wrap justify-end gap-6 lg:gap-8 text-sm">
            {navItems.map((item, index) => (
              item.to ? (
                <Link 
                  key={index}
                  to={item.to} 
                  className="flex items-center gap-2 hover:text-[#F2C1D1] transition-colors group"
                >
                  {item.icon}
                  <span>{item.label}</span>
                </Link>
              ) : (
                <button 
                  key={index}
                  onClick={item.action}
                  className="flex items-center gap-2 hover:text-[#F2C1D1] transition-colors group"
                >
                  {item.icon}
                  <span>{item.label}</span>
                </button>
              )
            ))}
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 hover:bg-[#D1B3C4] rounded-lg transition-colors"
            aria-label={isMobileMenuOpen ? 'Stäng meny' : 'Öppna meny'}
          >
            {isMobileMenuOpen ? (
              <X className="w-5 h-5" />
            ) : (
              <Menu className="w-5 h-5" />
            )}
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden fixed top-[3.5rem] left-0 right-0 bg-[#A3C1DA] border-t border-[#D1B3C4] 
                         py-4 px-4 space-y-4 shadow-lg z-50 max-h-[calc(100vh-3.5rem)] overflow-y-auto">
            {navItems.map((item, index) => (
              item.to ? (
                <Link 
                  key={index}
                  to={item.to} 
                  className="flex items-center gap-2 hover:text-[#F2C1D1] transition-colors group py-2"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {item.icon}
                  <span>{item.label}</span>
                </Link>
              ) : (
                <button 
                  key={index}
                  onClick={() => {
                    item.action?.();
                    setIsMobileMenuOpen(false);
                  }}
                  className="flex items-center gap-2 hover:text-[#F2C1D1] transition-colors group py-2 w-full text-left"
                >
                  {item.icon}
                  <span>{item.label}</span>
                </button>
              )
            ))}
          </div>
        )}
      </nav>

      <ContactModal 
        isOpen={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
      />

      <PaymentModal 
        isOpen={isPaymentModalOpen}
        onClose={() => setIsPaymentModalOpen(false)}
      />
    </>
  );
}
